import { Col, Modal, Row } from "react-bootstrap";
import TextInput from "../../common/textfield/TextInput";
import { useFormik } from "formik";
import { Button } from "../../common/Button";
import CallIcon from "@mui/icons-material/Call";
import CallEndIcon from "@mui/icons-material/CallEnd";
import { useEffect, useRef } from "react";
import alert from "../../../assets/sounds/alert.wav";

const ModalPopup = ({ data, onShow, onHide, handleProceedClick }) => {

  const formik = useFormik({
    initialValues: {
      dni: data?.dni || "",
      contactId: data?.contactId || "",
      agentId: data?.agentId || "",
      ani: data?.ani || "",
      skillName: data?.skillName || "",
      serviceLineId: data?.serviceLineId || "",
      serviceLineName: data?.serviceLineName || "",
      orgName: data?.orgName || ""
    },

    onSubmit: (values) => {
      console.log(values);
    },
  });

  useEffect(() => {
    if (data) {
        const audio = new Audio(alert);
        audio.play().catch((error) => {
            console.log("Audio playback failed:", error);
        });
    }
  }, []);

  if (!onShow) return null;

  return (
    <Modal
      backdropClassName
      backdrop={"static"}
      show={onShow}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      className="custom-dialog"
    >
      <Modal.Header className="border-0">
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={{ textTransform: "capitalize" }}
        >
          {"Incoming Interaction from Telephony Agent"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          className="common-form border-fields"
          onSubmit={formik.handleSubmit}
        >
          <Row>
            <Col>
              <TextInput
                keyField={`ani`}
                hideRequired={true}
                placeholder={"ANI"}
                label={"ANI"}
                tooltip={"The number from which the caller dialed"}
                formik={formik}
                disabled={true}
              />
            </Col>
            <Col>
              <TextInput
                keyField={`dni`}
                hideRequired={true}
                placeholder={"DNI"}
                label={"DNI"}
                tooltip={"The number dialed by the caller"}
                formik={formik}
                disabled={true}
              />
            </Col>
            <Col>
              <TextInput
                keyField={`orgName`}
                hideRequired={true}
                placeholder={"Organization"}
                label={"Organization"}
                formik={formik}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInput
                keyField={`contactId`}
                hideRequired={true}
                placeholder={"Contact ID"}
                label={"Contact ID"}
                formik={formik}
                tooltip={"The unique id of call from telephony agent"}
                disabled={true}
              />
            </Col>
            <Col>
              <TextInput
                keyField={`agentId`}
                hideRequired={true}
                placeholder={"Agent ID"}
                label={"Agent ID"}
                tooltip={"User identifier from telephony agent"}
                formik={formik}
                disabled={true}
              />
            </Col>
            <Col>
              <TextInput
                keyField={`serviceLineName`}
                hideRequired={true}
                placeholder={"Service Line"}
                label={"Service Line"}
                formik={formik}
                disabled={true}
              />
            </Col>
          </Row>
          <div className="action-wrap">
            <Button
              className="success-btn"
              onClick={() => handleProceedClick(data)}
              variant="primary"
              style={{ marginRight: "20px" }}
              startIcon={<CallIcon style={{ color: "white" }} />}
              title="Proceed"
            >
              Proceed
            </Button>
            <Button
              className="delete-btn"
              onClick={() => onHide()}
              variant="primary"
              startIcon={<CallEndIcon style={{ color: "white" }} />}
              title="Cancel"
            >
              Cancel
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalPopup;
